import { render, staticRenderFns } from "./DealListComponent.vue?vue&type=template&id=a6173a1e&scoped=true&"
import script from "./DealListComponent.vue?vue&type=script&lang=ts&"
export * from "./DealListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DealListComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DealListComponent.vue?vue&type=style&index=1&id=a6173a1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6173a1e",
  null
  
)

export default component.exports